import { render, staticRenderFns } from "./CustomizeLayoutPattern.vue?vue&type=template&id=c66845be&"
import script from "./CustomizeLayoutPattern.vue?vue&type=script&lang=js&"
export * from "./CustomizeLayoutPattern.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeLayoutPattern.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports